import React, { useEffect } from 'react';
import PageContent from '../../components/Page/components/PageContent';
import log from '../../helpers/Logger';

/**
 * A component that renders the access denied page
 */
export default function AccessDenied() {
  useEffect(() => {
    log.warn('Insufficient permissions');
  }, []);

  return (
    <PageContent title="Accesso negato">
      <h3>Non hai i permessi per accedere alla risorsa richiesta</h3>
    </PageContent>
  );
}
